import { Blue80 } from "@traceair/tds";

export const getContactUsLink = (title: string) =>
  `<a href="mailto:${CS_TEAM_EMAIL}" style="text-decoration: none; color: ${Blue80}; ">${title}</a>`;

export const interpolateTemplate = (
  template: string,
  params: Record<string, string | number>
): string => {
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    return key in params ? String(params[key]) : `{${key}}`;
  });
};

export const pluralize = (
  count: number,
  singular: string,
  plural: string
): string => {
  return `${count} ${count === 1 ? singular : plural}`;
};
